"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertBreakoutFiltersToMetrics = void 0;
var lodash_1 = __importDefault(require("lodash"));
/**
 * Returns an array of m * n length metrics for a multi-metric request with breakout filters applied.
 * We make one data request for the widget for each breakout filter, and this is multiplied by each metric.
 */
var convertBreakoutFiltersToMetrics = function (breakoutFilters, metrics) {
    // @ts-ignore
    var breakoutFilterMetrics = [];
    lodash_1.default.forEach(metrics, function (originalMetric) {
        lodash_1.default.forEach(breakoutFilters, function (filter) {
            var metric = lodash_1.default.cloneDeep(originalMetric);
            metric.filters = filter;
            breakoutFilterMetrics.push(metric);
        });
    });
    // @ts-ignore
    return breakoutFilterMetrics;
};
exports.convertBreakoutFiltersToMetrics = convertBreakoutFiltersToMetrics;
